import { PickersShortcuts } from "@mui/x-date-pickers";
import { css, styled } from "@mui/material";
import { Dayjs } from "dayjs";
import { wscType } from "../../../theme/wscTheme.types";

export const pickersShortcutsStyles = (props: {
  theme: { wsc: wscType };
}) => css`
  border-right: 0.071rem solid ${props.theme.wsc.palette.neutral[700]};
  margin: ${`${props.theme.wsc.spacing[3]} 0 ${props.theme.wsc.spacing[2]} 0`};
  padding: ${`0 ${props.theme.wsc.spacing[2]} 0 ${props.theme.wsc.spacing[2]}`};
  height: 25rem;
  max-height: 25rem;
  min-width: 10.571rem;

  .MuiListItem-root {
    padding: 0;
    margin-bottom: ${props.theme.wsc.spacing[2]};

    .MuiChip-root {
      ${props.theme.wsc.typography.body2};
      height: 2rem;
      color: ${props.theme.wsc.palette.neutral[100]};
      background-color: ${props.theme.wsc.palette.neutral[700]};
      border-radius: ${props.theme.wsc.radius.xl};

      .MuiChip-label {
        padding: 0 ${props.theme.wsc.spacing[1]};
      }

      &:hover {
        background-color: ${props.theme.wsc.palette.neutral[600]};
      }

      &:active {
        font-weight: ${props.theme.wsc.typography.body2bold.fontWeight};
        color: ${props.theme.wsc.palette.primary[300]};
        background-color: ${props.theme.wsc.palette.neutral[500]};
      }

      &.Mui-disabled {
        opacity: 1;
        color: ${props.theme.wsc.palette.neutral[300]};
        background: none;
      }
    }
  }
`;

export const StyledPickersShortcuts = styled(PickersShortcuts<Dayjs | null>)(
  pickersShortcutsStyles,
);
